import React, { useMemo } from "react";
import { FinancialConnectionWithAccounts } from "@common/types/financialConnection";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Collapsible } from "@design-system/Collapsible/Collapsible";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { timeAgo } from "@helpers/date";
import { ClockIcon } from "@icons";
import { DisplayIntegrationAccount } from "../integrationAccount/DisplayIntegrationAccount";
import css from "./RampConnectionStatus.module.scss";

interface Props {
    connection: FinancialConnectionWithAccounts;
}

export const RampConnectionStatus: React.FC<Props> = ({ connection }) => {
    const mostRecentTransactionsSyncedAt = useMemo(() => {
        const { accounts } = connection;
        const dates = accounts
            .map(({ transactionsSyncedAt }) => transactionsSyncedAt)
            .filter(Boolean) as Date[];

        return new Date(Math.max(...dates.map((date) => date.getTime())));
    }, [connection]);

    const header = (
        <div className={css.header}>
            <InstitutionIcon institution="ramp" size="lg" />
            <main>
                <h5>Ramp</h5>
                {mostRecentTransactionsSyncedAt && (
                    <small>
                        <ClockIcon
                            height={12}
                            width={12}
                            className="icon-color-current"
                        />
                        {timeAgo(mostRecentTransactionsSyncedAt)}
                    </small>
                )}
            </main>
        </div>
    );

    if (connection.accounts.length === 0) {
        return null;
    }

    return (
        <Collapsible className={css.rampConnection} header={header}>
            <>
                {connection.accounts.map((account) => (
                    <DisplayIntegrationAccount
                        key={account.id}
                        className={css.displayAccount}
                        connection={connection}
                        integrationAccount={account}
                    />
                ))}
            </>
        </Collapsible>
    );
};
